import React from 'react';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import ContractDetailContainer from './ContractDetailContainer';
import Separator from '../../../core/layout/Separator';
import UpgradeContractFormContainer from './UpgradeContractFormContainer';
import UpgradeContractProductsModalContainer from './UpgradeContractProductsModalContainer';

const UpgradeContractFormScene = (props) => (
  <>
    <Breadcrumb
      crumbs={[
        ...(props.location.state && props.location.state.from
          ? [{ text: props.location.state.from.text, link: props.location.state.from.pathname }]
          : []),
        {
          text: 'Upgrade Contract',
        },
      ]}
    />
    <ContractDetailContainer contractId={props.params.contractId} />
    <Separator />
    <UpgradeContractFormContainer contractId={props.params.contractId} />
    <UpgradeContractProductsModalContainer />
  </>
);

export default UpgradeContractFormScene;
